import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tir-pm-task-list" }
const _hoisted_2 = { class: "tir-subtasks-container" }
const _hoisted_3 = { class: "tir-pm-sub-task-container" }

import { PropType, inject, Ref, computed, ref, watch } from 'vue';
import { TasksListWrapper } from './';
import { DragModel, TirPmDraggable } from '../../tir-pm-kanban';
import { TaskCard } from './task-card';
import { TaskModel } from '../../tasks-kanban/models';
import { TasksKanbanGrouppingTypeEnum } from '../../tasks-kanban/enums';
import { ListItemModel } from './../models';
import GetAccessCurrentUserInQueueTaskByIdResponseModel from '../models/GetAccessCurrentUserInQueueTaskByIdResponseModel';

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-list',
  props: {
  /**Задача */
  task: { type: Object as PropType<DragModel<TaskModel>> },
  /**Тип группировки */
  grouppingType: { type: Number as PropType<TasksKanbanGrouppingTypeEnum> },
  /**Уровень вложенности */
  deepLevel: { type: Number, default: 0 },
  /**Размер имени задачи */
  nameWidth: { type: String },
  /**Размеры колонок списка */
  listColumns: { type: Array as PropType<ListItemModel[]> },
  /**Видимость данных группировки в карточке */
  visibleTaskGroupData: { type: Boolean, default: false },
  /**С какого уровня будут видны данные группировки в карточке */
  visibleTaskGroupDataStartLevel: { type: Number, default: 0 },
  /**Доступы юзера к очереди */
  userAccess: { type: Object as PropType<GetAccessCurrentUserInQueueTaskByIdResponseModel> },
},
  emits: ["dragComponentOnDrag", "dragComponentOnOver", "dragComponentOnDrop", "loadSubtasks", "open", "removeTask"],
  setup(__props, { emit }) {

const props = __props;


/**События компонента */


/**Список id задач */
const tempTasksIds = [];
/**Виден ли список подзадач из текущей очереди */
const isCurrentSubtasksVisible = ref(false);
/**Виден ли список подзадач из других очередей */
const isOtherSubtasksVisible = ref(false);

/**Перетаскиваемый элемент */
const currentDragging = inject<Ref<DragModel<TaskModel>>>('currentDragging');
/**Элемент над которым находится перетаскиваемый объект */
const overDragging = inject<Ref<DragModel<TaskModel>>>('overDragging');
/**Id очереди */
const queueId = inject('queueId') as Ref<string>;

/**Перетаскивание разрешено */
const dragAllowed = computed(() => {
  return [
    TasksKanbanGrouppingTypeEnum.Status,
    TasksKanbanGrouppingTypeEnum.Priority,
    TasksKanbanGrouppingTypeEnum.Type,
    TasksKanbanGrouppingTypeEnum.None,
  ].includes(props.grouppingType);
});
/**Над этим элементом находится перетаскиваемый объект */
const isOver = computed(() => {
  return (
    !!currentDragging.value &&
    currentDragging.value.Data.Id != props.task.Data.Id &&
    overDragging?.value?.Data.Id === props.task?.Data.Id &&
    checkAllowOver()
  );
});
/**Текущая задача перетаскивается */
const isTaskDragging = computed(() => currentDragging.value?.Data?.Id == props.task.Data.Id);
/**Видны ли подзадачи */
const isSubtasksVisible = computed(
  () =>
    props.task?.Data?.Subtasks?.length &&
    (isCurrentSubtasksVisible.value || isOtherSubtasksVisible.value),
);
/**Отображаемые подзадачи */
const visibleSubtasks = computed(() => {
  if (isCurrentSubtasksVisible.value && isOtherSubtasksVisible.value) {
    return props.task.Data.Subtasks;
  }

  return props.task.Data.Subtasks.filter((t) => {
    const isCurrent = t.CheckIsCurrentQueue(queueId.value);
    if (isCurrentSubtasksVisible.value) {
      return isCurrent;
    }
    if (isOtherSubtasksVisible.value) {
      return !isCurrent;
    }
  });
});

/**Перетаскивание элемента */
const dragComponentOnDrag = (isDragging: boolean, model: DragModel<any>) => {
  emit('dragComponentOnDrag', isDragging, model);
};
/**Элемент над которым перетаскивается */
const dragComponentOnOver = (isOver: boolean, model: DragModel<any>) => {
  emit('dragComponentOnOver', isOver, model);
};
/**Проверка разрешения наведения */
const checkAllowOver = () => {
  if (!currentDragging.value) return false;

  const item = currentDragging.value.Data;
  const ids = [item.ParentTaskId, item.Id, ...getDeepArrayIds(item.Subtasks)];
  if (ids.includes(props.task.Data.Id)) return false;

  return true;
};

/**Рекурсивное заполение id групп */
const getDeepArrayIds = (tasks: TaskModel[]) => {
  tasks?.forEach((item) => {
    if (item?.Id) {
      tempTasksIds.push(item.Id);
    }
    if (item?.Subtasks?.length) {
      getDeepArrayIds(item.Subtasks);
    }
  });
  return tempTasksIds;
};
/**Сброс узла с тасками */
const dragComponentOnDrop = (model: DragModel<TaskModel>) => {
  if (!isOver.value) return;
  emit('dragComponentOnDrop', model);
};
/**Переключение видимости задач из текущей очереди */
const toggleCurrentSubTasks = () => {
  if (!props.task.Data.Subtasks.length) emit('loadSubtasks', props.task.Data);
  isCurrentSubtasksVisible.value = !isCurrentSubtasksVisible.value;
};
/**Переключение видимости задач из других очередей */
const toggleOtherSubTasks = () => {
  if (!props.task.Data.Subtasks.length) emit('loadSubtasks', props.task.Data);
  isOtherSubtasksVisible.value = !isOtherSubtasksVisible.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["tir-wrapper-draggable", { over: isOver.value }])
    }, [
      _createVNode(_unref(TirPmDraggable), {
        class: "drag_component",
        "is-allow-click-delay": "",
        dragModel: __props.task,
        isAllowScroll: true,
        onDragging: dragComponentOnDrag,
        onOver: dragComponentOnOver,
        onDrop: dragComponentOnDrop
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(TaskCard), {
              task: __props.task,
              userAccess: __props.userAccess,
              isTaskDragging: isTaskDragging.value,
              isOver: isOver.value,
              deepLevel: __props.deepLevel,
              nameWidth: __props.nameWidth,
              listColumns: __props.listColumns,
              dragAllowed: dragAllowed.value,
              "visible-task-group-data": 
              __props.visibleTaskGroupData && __props.deepLevel >= __props.visibleTaskGroupDataStartLevel
            ,
              "groupping-type": __props.grouppingType,
              onCurrent: toggleCurrentSubTasks,
              onOther: toggleOtherSubTasks,
              onOpen: _cache[0] || (_cache[0] = ($event: any) => (emit('open', $event))),
              onRemoveTask: _cache[1] || (_cache[1] = ($event: any) => (emit('removeTask', $event)))
            }, null, 8, ["task", "userAccess", "isTaskDragging", "isOver", "deepLevel", "nameWidth", "listColumns", "dragAllowed", "visible-task-group-data", "groupping-type"])
          ])
        ]),
        _: 1
      }, 8, ["dragModel"])
    ], 2),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(TasksListWrapper), {
        tasks: visibleSubtasks.value,
        "groupping-type": __props.grouppingType,
        deepLevel: __props.deepLevel + 1,
        nameWidth: __props.nameWidth,
        listColumns: __props.listColumns,
        "visible-task-group-data": __props.visibleTaskGroupData,
        "visible-task-group-data-start-level": __props.visibleTaskGroupDataStartLevel,
        onOpen: _cache[2] || (_cache[2] = ($event: any) => (emit('open', $event))),
        onDragComponentOnDrag: dragComponentOnDrag,
        onDragComponentOnOver: dragComponentOnOver,
        onDragComponentOnDrop: _cache[3] || (_cache[3] = ($event: any) => (emit('dragComponentOnDrop', $event))),
        onLoadSubtasks: _cache[4] || (_cache[4] = ($event: any) => (emit('loadSubtasks', $event)))
      }, null, 8, ["tasks", "groupping-type", "deepLevel", "nameWidth", "listColumns", "visible-task-group-data", "visible-task-group-data-start-level"])
    ], 512), [
      [_vShow, isSubtasksVisible.value]
    ])
  ]))
}
}

})